const menuPtMessages = {
  'menu.dashboard': 'Painel de controle',
  'menu.notifications': 'Notificações',
};
export default menuPtMessages;
